import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../../hooks/useMetaPixel';
interface CTAButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  text,
  onClick,
  className = '',
  href
}: CTAButtonProps) {
  const baseClasses = `
    relative inline-flex items-center justify-center 
    px-8 py-4 text-lg md:text-xl font-bold text-brand-navy 
    bg-brand-gold rounded-lg shadow-glow-gold
    transition-all duration-300
    hover:bg-brand-goldHover hover:shadow-glow-gold-lg hover:-translate-y-1
    ${className}
  `;
  const fireAddToCart = () => {
    trackEvent('AddToCart', {
      content_name: 'El Código del Silencio',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    onClick?.();
  };
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className="w-full h-full flex items-center justify-center" data-id="element-200">
      {text}
    </motion.div>;
  if (href) {
    const isInternal = href.startsWith('#');
    return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} onClick={isInternal ? undefined : fireAddToCart} className={baseClasses} data-id="element-201">
        {content}
      </a>;
  }
  return <a href="https://claridaddiaria.com/cart/43044425859138:1" target="_blank" rel="noopener noreferrer" onClick={fireAddToCart} className={baseClasses} data-id="element-202">
      {content}
    </a>;
}